import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next';
import ApiGo from '../../../actions/ApiGo';


const TCPIP_Setting =(props)=>{
    const reg = '^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$'
    // const reg = '\w{3,16}'
    const {t} = useTranslation()
    const [TCPIPsetting, setTCPIPsetting] = useState(0);
    const [currentBroadcast, setCurrentBroadcast] = useState('');
    const [currentGateway, setCurrentGateway] = useState('');
    const [currentIP, setCurrentIP] = useState('');
    // const [currentIP6, setCurrentIP6] = useState('');
    const [currentNetmask, setCurrentNetmask] = useState('');
    const [currentDNS1, setCurrentDNS1] = useState('');
    const [currentDNS2, setCurrentDNS2] = useState('');
    const [context, setContext] = useState("");
    const [alertBool, setAlertBool] = useState(false);
    const [confirmBool, setConfirmBool] = useState(false);
    const [inputDisableBool, setInputDisableBool] = useState(false);
    function redirect() {
        window.location.href = "http://"+currentIP
    }

    useEffect(()=>{
        if(TCPIPsetting===1) setInputDisableBool(true)
        else if(TCPIPsetting===2) setInputDisableBool(true)
        else setInputDisableBool(false)
    }, [TCPIPsetting])

    function post_manual_setting() {
        let data = {
            "connection_method": "manual_setting",
            "ip": currentIP,
            "netmask": currentNetmask,
            "DNS1": currentDNS1,
            "DNS2": currentDNS2,
            "gateway":currentGateway
          }
        if(TCPIPsetting===1){
            data.connection_method = "DHCP"
        }
        if(TCPIPsetting===2){
            data.connection_method = "init_setting"
        }
        return new Promise((resolve, reject)=>{
            setConfirmBool(true)
            setContext(t('ADMIN.NETWORK_SETTING.CONFIRM_PROTOCOL_FORMAT'))
            setTimeout(()=>{
                redirect()
            },10000)
            ApiGo.post_manual_setting(data)
            .then(res=>{ console.log(res); })
            .catch(err=>{ console.log(err); })
        })
    }

    useEffect(()=>{
        // 限制抓一次
        ApiGo.get_current_tcp_ip_info()
        .then(res=>{
            res.forEach(str=>{
                let arr = str.split(": ")
                switch (arr[0]) {
                    case "current_broadcast":
                        setCurrentBroadcast(arr[1])
                        break;
                    case "current_gateway":
                        setCurrentGateway(arr[1])
                        break;
                    // case "current_ip6":
                    //     setCurrentIP6(arr[1])
                    //     break;
                    case "current_ip":
                        setCurrentIP(arr[1])
                        break;
                    case "current_netmask":
                        setCurrentNetmask(arr[1])
                        break;
                    case "current_DNS1":
                        setCurrentDNS1(arr[1])
                        break;
                    case "current_DNS2":
                        setCurrentDNS2(arr[1])
                        break;
                    case "current_connection_method":
                        if(arr[1]==="Manual method!") setTCPIPsetting(0)
                        else setTCPIPsetting(1)
                        break;
                    default:
                        break;
                }
            });
        })
        .catch(err=>{ console.log(err); })
    }, [])

    useEffect(()=>{
        setTimeout(()=>{
            setContext(t("ADMIN.NETWORK_SETTING.REDIRECT_5SECOND"))
        }, 5000)
    },[context])

    const Alert_div = <div className="wid-admin-full hig-full pos-f z-1 top-0 rgt-0 fx-cc " onClick={e=>e.stopPropagation()}>
        <div className={`wid-admin-30 br-20 fx-d-c fx-cc shadow-s-noHover hig-30 bgC-white border`}>
            <div className="fontw-b">{t("ADMIN.NETWORK_SETTING.WARNING")}</div>
            {TCPIPsetting===1?<>
                    <div className="font-m">{t('ADMIN.NETWORK_SETTING.DHCP_REASSIGN_IP')}</div>
                    <div className="font-m">{t('ADMIN.NETWORK_SETTING.DHCP_DISCONNECT_WARNING')}</div>
                    <div className="font-m">{t('ADMIN.NETWORK_SETTING.CHECK_HOST_IP')}</div>
                </>:
            TCPIPsetting===0?
                <div className="fontw-b">{t("ADMIN.NETWORK_SETTING.RESET_WARNING")}</div>
            :<>
                <div className="font-m">{t('ADMIN.NETWORK_SETTING.RESTORE_DEFAULT_WARNING')}</div>
                <div className="font-m">{t('ADMIN.NETWORK_SETTING.DHCP_DISCONNECT_WARNING')}</div>
                <div className="font-m">{t('ADMIN.NETWORK_SETTING.CHECK_HOST_IP')}。</div>
            </>}
            {(!confirmBool)?<div className="fx-d-r fx-cspar wid-admin-m margt-s">
                    <div className="wid-admin-xs hig-xs bgC-alert-EE br-10 shadow-xs fx-cc" onClick={post_manual_setting}>{t("GLOBAL.CONFIRM")}</div>
                    <div className="wid-admin-xs hig-xs bgC-alert-E br-10 shadow-xs fx-cc" onClick={props.hide}>{t("GLOBAL.CANCEL")}</div>
                </div>:
                <div className="fx-ccc wid-admin-m margt-s running_dot">{context}</div>}
        </div>
    </div>

    return(
        <div className="wid-admin-full hig-full pos-f z-2000 top-0 lft-0 cursor_style fx-cc default" onClick={props.hide}>
            {(alertBool)?Alert_div:
            <div className={`wid-admin-l hig-75 fx-d-c bgC-white border shadow-s-noHover br-20 cursor_style default`} onClick={e=>e.stopPropagation()}>
                <div className="fx-d-r margt-5-vh hig-l margl-s">
                    <div className="fx-d-c hig-l w-80">
                        <div className="font-l">{t("ADMIN.NETWORK_SETTING.ADVANCED")}{t("ADMIN.NETWORK_SETTING.CONFIG")}</div>
                        <div className="hig-xs margt-xsvh fx-d-c">
                            <div>{t("ADMIN.NETWORK_SETTING.OPTIONS")}</div>
                            <div className="fx-d-r" onClick={()=>{setTCPIPsetting(0)}}>
                                <input id='manual_setting' type='radio' name='setting' value="manual_setting" onClick={()=>{setTCPIPsetting(0)}}/>
                                <label htmlFor='manual_setting' className="padl-1">{t("ADMIN.NETWORK_SETTING.MANUAL")}</label>
                                {/* <div className={`btn_switch_RES ${TCPIPsetting!==0?"red":'on_Click green'}`}></div> */}
                            </div>
                            <div>
                                <div className="fx-d-r" >
                                    <input id='DHCP' type='radio' name='setting'  value="DHCP" onClick={()=>{setTCPIPsetting(1)}}/>
                                    <label htmlFor='DHCP' className="padl-1">{t("ADMIN.NETWORK_SETTING.DHCP")}</label>
                                    {/* <div className={`btn_switch_RES ${TCPIPsetting!==1?"red":'on_Click green'}`}></div> */}
                                </div>
                            </div>
                            <div>
                                <div className="fx-d-r" >
                                    <input id="init_setting" type='radio' name='setting'  value="init_setting" onClick={()=>{setTCPIPsetting(2)}}/>
                                    <label htmlFor="init_setting" className="padl-1">{t("ADMIN.NETWORK_SETTING.RESTORE_DEFAULT")}</label>
                                    {/* <div className={`btn_switch_RES ${TCPIPsetting!==2?"red":'on_Click green'}`}></div> */}
                                </div>
                            </div>

                            <div className=' margt-xsvh'>{t("ADMIN.NETWORK_SETTING.MANUAL_CONFIG")}</div>

                            <div className="border br-10 pad_for_internetsetting wid-admin-side margt-xs">
                                <div className="fx-d-r margt-xxs">
                                    <div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.IP_ADDR")}:</div>
                                    <input type="text" className='inputIP' onChange={e=>setCurrentIP(e.target.value)} value={currentIP} disabled={inputDisableBool} pattern={reg}/>
                                </div>
                                <div className="fx-d-r margt-xxs">
                                    <div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.NETMASK")} :</div>
                                    <input type="text" className='inputIP' onChange={e=>setCurrentNetmask(e.target.value)} value={currentNetmask} disabled={inputDisableBool} pattern={reg}/>
                                </div>
                                {/* <div className="fx-d-r margt-xxs margb-xxs">
                                    <div className="wid-admin-s">IPv6:</div>
                                    <div>{currentIP6}</div>
                                </div> */}
                                <div className="fx-d-r margt-xxs margb-xxs">
                                    <div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.DEFAULT_GATEWAY")} :</div>
                                    <input type="text" className='inputIP' onChange={e=>setCurrentGateway(e.target.value)} value={currentGateway} disabled={inputDisableBool} pattern={reg}/>
                                    {/* <div>{currentGateway}</div> */}
                                </div>
                                <div className="fx-d-r margt-xxs margb-xxs">
                                    <div className="wid-admin-s">{t("ADMIN.NETWORK_SETTING.SEGMENT")} :</div>
                                    {/* <input type="text" className='inputIP' onChange={e=>setCurrentBroadcast(e.target.value)} value={currentBroadcast}/> */}
                                    <div>{currentBroadcast}</div>
                                </div>

                            </div>
                            <div className="border br-10 pad_for_internetsetting wid-admin-side margt-xxs">
                                <div className="fx-d-r margt-xxs margb-xxs">
                                    <div className="wid-admin-s">DNS :</div>
                                    <div className='fx-d-c'>
                                        <input type="text" className='inputIP' onChange={e=>{setCurrentDNS1(e.target.value)}} value={currentDNS1} disabled={inputDisableBool} pattern={reg}/>
                                        <input type="text" className="margt-xxs inputIP" onChange={e=>{setCurrentDNS2(e.target.value)}} value={currentDNS2} disabled={inputDisableBool} pattern={reg}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`wid-admin-l fx-d-r fx-cspar pos-f btm-15`}>
                    <div className="wid-admin-xs hig-xs bgC-alert-E br-10 shadow-xs fx-cc" onClick={()=>{setAlertBool(true)}}>{t("GLOBAL.CONFIRM")}</div>
                    <div className="wid-admin-xs hig-xs bgC-alert-EE br-10 shadow-xs fx-cc" onClick={props.hide}>{t("GLOBAL.CANCEL")}</div>
                </div>
            </div>}
        </div>
    );

}
export default TCPIP_Setting;